/**
 * GENERATED — do not edit by hand.
 *   node scripts/generateTierDuelEstimates.js
 *
 * How many duels a tier's Moonlight is worth, as a RANGE. It is a range and
 * never a single number because the player holds two levers: PvP splits a
 * duel's cost between both seats, and manga costs more than the text. `low` is
 * the honest worst case for how that tier is played; `high` is solo PvP-free
 * best case. The store hedges both with "about".
 *
 * Derived from the live cost model, each tier priced on the model it actually
 * runs. Kept honest by tests/unit/ui/tierDuelEstimatesParity.test.js.
 */

export const TIER_DUEL_ESTIMATES = Object.freeze({
  free: Object.freeze({ solo: 25, pvp: 50 }),
  moonfall_storyteller: Object.freeze({ solo: 50, pvp: 100, normalAi: 100 }),
  moonfall_manga: Object.freeze({ solo: 105, pvp: 210, manga: 35, normalAi: 210, mangaNormalAi: 45 }),
});
